import { CrudService } from "./crud";
import {
  Franquia,
  FranquiaInput,
  FranquiaUpdateInput,
  PaginatedFranquiaResponse,
} from "../types/franquia";
import api from "./api";

class FranquiaService extends CrudService<Franquia> {
  constructor() {
    super("/api/franquias/");
  }

  async criar(franquia: FranquiaInput): Promise<Franquia> {
    const response = await api.post<Franquia>("/api/franquias/", franquia);
    return response.data;
  }

  async buscarPorId(id: number): Promise<Franquia> {
    return this.get(id);
  }

  async atualizar(
    id: number,
    franquia: FranquiaUpdateInput
  ): Promise<Franquia> {
    const response = await api.put<Franquia>(`/api/franquias/${id}/`, franquia);
    return response.data;
  }

  async atualizarParcial(
    id: number,
    franquia: FranquiaUpdateInput
  ): Promise<Franquia> {
    const response = await api.patch<Franquia>(
      `/api/franquias/${id}/`,
      franquia
    );
    return response.data;
  }

  async excluir(id: number): Promise<void> {
    return this.delete(id);
  }

  async listar(
    page: number = 1,
    pageSize: number = 10
  ): Promise<PaginatedFranquiaResponse> {
    const response = await api.get<PaginatedFranquiaResponse>(
      `/api/franquias/?page=${page}&page_size=${pageSize}`
    );
    return response.data;
  }

  async removerMembro(franquiaId: number, membroId: number): Promise<void> {
    await api.delete(`/api/franquias/${franquiaId}/membros/${membroId}/`);
  }

  async definirNovoAdmin(franquiaId: number, userId: number): Promise<void> {
    await api.post(`/api/franquias/${franquiaId}/definir_novo_admin/`, {
      user_id: userId,
    });
  }

  async registrarFranquia(data: any): Promise<any> {
    const response = await api.post("/api/franquias/registrar-franquia/", data);
    return response.data;
  }
}

export const franquiaService = new FranquiaService();
